import { CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Select,
  Slider,
  Space,
  Switch,
  message,
} from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { UploadFile } from "antd/lib/upload/interface";
import ModalConfirm from "app/components/ConfirmExit";
import LogoLoading from "app/components/Logo";
import SunEditorCustom from "app/components/SunEditorCustom";
import TinyEditor from "app/components/TinyEditor/TinyEditor";
import {
  APP_SETTINGS,
  CURRENCY,
  EEditorType,
  EInventoryBuildingClass,
  EInventoryLabel,
  EInventoryRentalArea,
  EInventorySpaceType,
  FORM_MODE,
} from "constant";
import { PAGE_ROUTE } from "constant/routes/page";
import dayjs, { Dayjs } from "dayjs";
import { useGetParamsUrl, useHandleSubmitApi } from "hook";
import {
  ESourceTagRelation,
  ICreateInventoryInputMode,
  IGetDetailInventoryOutputModel,
  IInvetoryInformationInputModel,
  IUpdateInventoryInputMode,
  TInventoryImageFormData,
  TTagOutputModel,
} from "interfaces";
import { TDistrictOutputModel, TProvinceOutputModel, TWardOutputModel } from "interfaces/province";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FileServices } from "services/file";
import { InventoryServices } from "services/inventory";
import { TagService } from "services/tag";
import { DivisionUtils } from "utils/division";
import { FormDataUtil } from "utils/form";
import { OtherUtil } from "utils/other";
import HistoryInventoryForm from "../HistoryInventoryForm/HistoryInventoryForm.presenter";
import InventoryImageForm from "./InventoryImageForm.presenter";

type P_Props = {
  onClose: () => void;
};

type IStateInventoryForm = IInvetoryInformationInputModel & {
  title: string;
  investorName: string;
  isShow: boolean;
  buildingClass: EInventoryBuildingClass | null;
  spaceTypeBuilding: EInventorySpaceType | null;
  // floorSpaceBuilding: EInventoryRentalArea | null;
  floorSpaceBuilding: string;
  operatingTime: string | Dayjs | null;
  label: EInventoryLabel | null;

  areaRange: number[];

  rentalArea: EInventoryRentalArea | null;
  totalRentalArea: number | null;

  parking: string | null;
  powerBackup: string | null;

  price: number[];

  // province
  province: number | null;
  district: number | null;
  ward: number | null;
  address: string;
  coordinates: string;
  iframeMap: string;

  // seo
  allowSeo?: boolean;
  titleSeo: string | null;
  descSeo: string | null;
  slug: string;
  keywords?: string[];

  inventoryImages: any;
};
// Building specifications

const initialValues: IStateInventoryForm = {
  title: "",
  investorName: "",
  isShow: false,
  buildingClass: null,
  spaceTypeBuilding: null,
  floorSpaceBuilding: "",
  operatingTime: "",
  label: null,
  rentalArea: null,

  totalRentalArea: null,
  powerBackup: null,

  parking: null,

  areaRange: [0],

  price: [20, 80],

  // province
  province: 1,
  district: null,
  ward: null,
  address: "",
  coordinates: "",
  iframeMap: "",

  // seo
  allowSeo: false,
  titleSeo: null,
  descSeo: null,
  slug: "",
  keywords: [],

  inventoryImages: null,

  // Building specifications
  height: "",
  airConditioning: "",
  // parkingAvailable: "",
  electricitySurcharge: "",
  workingHours: "",
  elevatorAvailable: "",
  buildingOrientation: "",

  // Price details, service fees and other costs
  rentalPrice: "",
  serviceFee: "",
  tax: "",
  carParkingAvailable: "",
  motorcycleParkingAvailable: "",
  electricityAirconIncluded: "",

  //Rental area
  typicalFloor: "",
  ceilingHeight: "",
  additionalInfo: "",
  imageBuildingOrientation: null,

  // More information
  moreInformation: "",
};

const InventoryFormPresenter = (props: P_Props) => {
  const [form] = useForm();
  const { Panel } = Collapse;
  const { t } = useTranslation("translation");
  const navigate = useNavigate();
  const pathName = window.location.pathname;
  const mode = pathName === PAGE_ROUTE.ADM_INVENTORY_CREATE ? FORM_MODE.CREATE : FORM_MODE.EDIT;
  const dataParams = useGetParamsUrl<{ id: string }>();

  const [content, setContent] = useState("");
  // const [initialContent, setInitialContent] = useState("");
  const [visibleExit, setVisibleExit] = useState(false);
  const [formValues, setFormValues] = useState<IStateInventoryForm>(initialValues);

  const [provinces, setProvinces] = useState<TProvinceOutputModel[]>([]);
  const [districts, setDistricts] = useState<TDistrictOutputModel[]>([]);
  const [wards, setWards] = useState<TWardOutputModel[]>([]);
  // const [selectedThumbnail, setSelectedThumbnail] = useState<any>(null);
  // const [selected, setSelected] = useState<string[]>([]);
  const [tags, setTags] = useState<TTagOutputModel[]>([]);
  const [inputTag, setInputTag] = useState("");
  const [visibleHistory, setVisibleHistory] = useState<string | null>(null);

  const optionsProvince: { label: string; value: number }[] = provinces.map((o) => ({
    label: o.name,
    value: o.code,
  }));
  const optionsDistrict: { label: string; value: number }[] = districts.map((o) => ({ label: o.name, value: o.code }));
  const optionsWard: { label: string; value: number }[] = wards.map((o) => ({ label: o.name, value: o.code }));

  useEffect(() => {
    const listProvinces = DivisionUtils.getProvinces();
    const filterProvinceByCode = [1, 48, 79];
    const provinces = listProvinces.filter((p) => filterProvinceByCode.includes(p.code));
    setProvinces(provinces);
    handleFetchTag();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (dataParams?.id) {
      handleFetchDetailInventory(dataParams?.id);
    }
    // eslint-disable-next-line
  }, [dataParams?.id]);

  const [handleFetchDetailInventory, loadingDetail] = useHandleSubmitApi(async (inventoryId: string) => {
    const dataRes = await InventoryServices.getDetailInventory(inventoryId);
    if (dataRes) {
      handleBindDetail(dataRes.data);
    }
  });

  const [handleFetchTag, loadingTag] = useHandleSubmitApi(async () => {
    const dataRes = await TagService.getListTag({ source: ESourceTagRelation.INVENTORY });
    if (dataRes) {
      setTags(dataRes.data);
    }
  });

  const [handleCreateTag, loadingCreateTag] = useHandleSubmitApi(
    async (name: string) => {
      const dataRes = await TagService.createTag({ name, source: ESourceTagRelation.INVENTORY });
      if (dataRes) {
        await handleFetchTag();
        message.success("Tạo mới từ khoá thành công");

        handleChangeFormValues({ keywords: [...(formValues.keywords || []), dataRes.data.id] } as any);
      }
    },
    () => {
      message.error("Tạo mới từ khoá thất bại");
    }
  );

  const [handleRemoveTag, loadingRemoveTag] = useHandleSubmitApi(
    async (tagId: string) => {
      if (!tagId) return message.info("Có lỗi xảy ra, vui lòng thử lại sau!");
      const dataRes = await TagService.deleteTag(tagId, { source: ESourceTagRelation.INVENTORY });
      if (dataRes) {
        await handleFetchTag();
        message.success("Xoá từ khoá thành công!");

        handleChangeFormValues({
          keywords: [...(formValues.keywords || [])?.filter((keyword) => keyword !== tagId)],
        } as any);
      }
    },
    () => {
      message.error("Từ khoá đã được sử dụng!");
    }
  );

  const handleFetchDistricts = (provinceCode?: number) => {
    const district = DivisionUtils.getDistricts(provinceCode || 1);
    setDistricts(district);
  };

  const handleFetchWards = (districtCode?: number) => {
    const wards = DivisionUtils.getWard(districtCode || 1);
    setWards(wards);
  };

  const handleBindDetail = async (data: IGetDetailInventoryOutputModel) => {
    if (data) {
      if (data["province"]) {
        handleFetchDistricts(data["province"]);
      }

      if (data.ward) {
        handleFetchWards(data["district"]);
      }

      const inventoryImages: (UploadFile & {
        isThumbnail: boolean;
        module: "INVENTORY" | "MEDIA";
        originId?: string;
      })[] = data.inventoryImages.map((i) => ({
        uid: i.id,
        name: i.name,
        url: i.path,
        status: "done",
        isThumbnail: i.isThumbnail,
        module: "INVENTORY",
        originId: i.mediaId,
      }));

      const imageBuildingOrientation: (UploadFile & {
        isThumbnail: boolean;
        module: "INVENTORY" | "MEDIA";
        originId?: string;
      })[] = data.imageBuildingOrientation.map((i) => ({
        uid: i.id,
        name: i.name,
        url: i.path,
        status: "done",
        isThumbnail: i.isThumbnail,
        module: "INVENTORY",
        originId: i.mediaId,
      }));

      // if (!!inventoryImages && !!inventoryImages.length) {
      //   const findThumbnail = inventoryImages.find((i) => i.isThumbnail);

      //   if (findThumbnail) {
      //     setSelectedThumbnail(findThumbnail);
      //   }
      // }

      // const imageBuildingOrientation: UploadFile[] = data.imageBuildingOrientation.map((i) => ({
      //   uid: i.id,
      //   name: i.name,
      //   url: i.path,
      //   status: "done",
      // }));

      const initialValuesEdit: IStateInventoryForm = {
        title: data.title,
        investorName: data.investorName,
        isShow: data.isShow,
        buildingClass: (data.buildingClass || null) as EInventoryBuildingClass,
        spaceTypeBuilding: (data.spaceTypeBuilding || null) as EInventorySpaceType,
        // floorSpaceBuilding: (data.floorSpaceBuilding || null) as EInventoryRentalArea,
        floorSpaceBuilding: data.floorSpaceBuilding,
        operatingTime: data.operatingTime ? dayjs(data.operatingTime) : null,
        label: data.label || null,
        rentalArea: data.rentalArea,

        totalRentalArea: data.totalRentalArea,
        powerBackup: data.powerBackup,
        parking: data.parking,

        areaRange: data?.areaRange.map((a) => a.numberArea) || [],
        price: [+data.priceFrom, +data.priceTo],

        // province
        province: data.province,
        district: data.district,
        ward: data.ward,
        address: data.address,
        coordinates: `${data.centerLat}, ${data.centerLng}`,
        iframeMap: data.iframeMap || "",

        // seo
        allowSeo: data.allowSeo,
        titleSeo: data.titleSeo,
        descSeo: data.descSeo,
        slug: data.slug,
        keywords: data.keywords?.map((k) => k.id) || [],

        inventoryImages: inventoryImages,

        // Building specifications
        height: data.inventoryInformation.height,
        airConditioning: data.inventoryInformation.airConditioning,
        // parkingAvailable: data.inventoryInformation.parkingAvailable,
        electricitySurcharge: data.inventoryInformation.electricitySurcharge,
        workingHours: data.inventoryInformation.workingHours,
        elevatorAvailable: data.inventoryInformation.elevatorAvailable,
        buildingOrientation: data.inventoryInformation.buildingOrientation,

        // Price details, service fees and other costs
        rentalPrice: data.inventoryInformation.rentalPrice,
        serviceFee: data.inventoryInformation.serviceFee,
        tax: data.inventoryInformation.tax,
        carParkingAvailable: data.inventoryInformation.carParkingAvailable,
        motorcycleParkingAvailable: data.inventoryInformation.motorcycleParkingAvailable,
        electricityAirconIncluded: data.inventoryInformation.electricityAirconIncluded,

        //Rental area
        typicalFloor: data.inventoryInformation.typicalFloor,
        ceilingHeight: data.inventoryInformation.ceilingHeight,
        additionalInfo: data.inventoryInformation.additionalInfo,
        imageBuildingOrientation: imageBuildingOrientation || null,

        // More information
        moreInformation: data.inventoryInformation.moreInformation,
      };

      setContent(initialValuesEdit.moreInformation || "");
      // setInitialContent(initialValuesEdit.moreInformation || "");
      setFormValues(initialValuesEdit);
      form.setFieldsValue(initialValuesEdit);
    }
  };

  const handleChangeFormValues = (values: typeof initialValues) => {
    if (values["province"]) {
      handleFetchDistricts(values["province"]);
      values["district"] = null;
      values["ward"] = null;
    }

    if (values["district"]) {
      handleFetchWards(values["district"]);
      values["ward"] = null;
    }

    if (values["titleSeo"] !== undefined) {
      const slug = OtherUtil.convertSlugUnicode(values["titleSeo"] || "")
        .trim()
        .split(" ")
        .join("-");
      form.setFieldsValue({
        slug: slug,
      });
      values["slug"] = slug;
    }

    if (values["coordinates"]) {
      values["iframeMap"] = OtherUtil.iframeMapByCoordinates({
        lat: +values.coordinates?.split(",")[0] || 0,
        lng: +values.coordinates?.split(",")[1] || 0,
      });
    }

    setFormValues((prevData) => ({ ...prevData, ...values }));
    form.setFieldsValue({ ...values });
  };

  const handleSubmitApi = async (values: IStateInventoryForm) => {
    const provinceName = optionsProvince.find((o) => o.value === formValues.province);
    const districtName = optionsDistrict.find((o) => o.value === formValues.district);
    const wardName = optionsWard.find((o) => o.value === formValues.ward);
    const fullAddress =
      OtherUtil.getFullAddress(formValues.address, wardName?.label, districtName?.label, provinceName?.label) || "";

    const dataService: ICreateInventoryInputMode | IUpdateInventoryInputMode = {
      ...values,
      fullAddress,
      titleSeo: values["titleSeo"] || "",
      descSeo: values["descSeo"] || "",
      priceFrom: values["price"][0],
      priceTo: values["price"][1],
      operatingTime: String(dayjs(values["operatingTime"]).year()),

      areaRange: values["areaRange"],
      totalRentalArea: values["totalRentalArea"] || 0,
      parking: values["parking"] || "",
      powerBackup: values["powerBackup"] || "",

      // Building specifications
      height: values["height"],
      airConditioning: values["airConditioning"],
      // parkingAvailable: values["parkingAvailable"],
      electricitySurcharge: values["electricitySurcharge"],
      workingHours: values["workingHours"],
      elevatorAvailable: values["elevatorAvailable"],
      buildingOrientation: values["buildingOrientation"],

      // Price details, service fees and other costs
      rentalPrice: values["rentalPrice"],
      serviceFee: values["serviceFee"],
      tax: values["tax"],
      carParkingAvailable: values["carParkingAvailable"],
      motorcycleParkingAvailable: values["motorcycleParkingAvailable"],
      electricityAirconIncluded: values["electricityAirconIncluded"],

      //Rental area
      rentalArea: values["rentalArea"] || "",
      typicalFloor: values["typicalFloor"],
      ceilingHeight: values["ceilingHeight"],
      additionalInfo: values["additionalInfo"],

      // More information
      moreInformation: content,
      thumbnail: null,
    };

    if (!!values["inventoryImages"].length) {
      const thumbnails: TInventoryImageFormData[] = values.inventoryImages
        .filter((i: any) => Boolean(i.isThumbnail))
        ?.map((i: any) => ({
          inventoryImageId: i.uid,
          mediaId: i.originId,
          isThumbnail: true,
          index: 0,
        }));
      if (!thumbnails?.length) {
        return message.error("Vui lòng chọn ảnh Thumbnail!");
      }

      const images: TInventoryImageFormData[] = values.inventoryImages
        .filter((i: any) => !Boolean(i.isThumbnail))
        ?.map((i: any, idx: number) => ({
          inventoryImageId: i.uid,
          mediaId: i.originId,
          isThumbnail: false,
          index: idx + 1,
        }));
      dataService["dataInventoryImage"] = [...thumbnails, ...images];

      /**Remove Object Images */
      delete (dataService as any)["inventoryImages"];
    }

    if (!!values["imageBuildingOrientation"]?.length) {
      const images: TInventoryImageFormData[] = values.imageBuildingOrientation?.map((i: any, idx: number) => ({
        inventoryImageId: i.uid,
        mediaId: i.originId,
        isThumbnail: false,
        index: idx,
      }));
      dataService["dataImageBuildingOrientation"] = images;

      /**Remove Object Images */
      delete (dataService as any)["imageBuildingOrientation"];
    }

    if (values["moreInformation"]) {
      dataService["moreInformation"] = await handleImageUpload(content);
    }

    console.log(563, dataService);

    const result = _.omitBy(dataService, (value) => typeof value === "string" && !value);

    const formData = FormDataUtil.convertJsonToFormData(result, {
      handelObjectInArr: (input) => {
        const temp = FormDataUtil.transformObjectFormData({
          mainKey: input.mainKey,
          data: input.data,
          mainIdx: input.mainIdx,
          customKeyForm: ({ mainKey, key, mainIdx }) => {
            return `${mainKey}[${mainIdx}][${key}]`;
          },
        });
        return temp;
      },
    });

    // return;
    if (mode === FORM_MODE.CREATE) {
      await createFormData(formData);
    } else if (mode === FORM_MODE.EDIT) {
      await updateFormData(formData);
    }
  };

  const extractBase64FromContent = (content: string) => {
    const base64Regex = /data:image\/[^;]+;base64[^"]+/g;
    return content.match(base64Regex) || [];
  };

  const handleImageUpload = async (content: string) => {
    const base64Images: any = extractBase64FromContent(content);
    const updatedContent = await base64Images.reduce(async (content: string, base64Image: string) => {
      const imageData = base64Image.split(",")[1];
      const byteCharacters = atob(imageData);
      const byteArrays = new Uint8Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([byteArrays], { type: "image/jpeg" });

      const imageUrl = (await hadleUploadFiles({ files: [blob] })) as any;
      return content.replace(base64Image, imageUrl);
    }, content);
    return updatedContent;
  };

  const [createFormData, loadingCreate] = useHandleSubmitApi(async (formData: FormData) => {
    const dataRes = await InventoryServices.createInventory(formData);
    if (dataRes) {
      message.success("Tạo thông tin thành công");
      onBackHome();
    }
  });

  const [updateFormData, loadingUpdate] = useHandleSubmitApi(async (formData: FormData) => {
    if (dataParams && dataParams.id) {
      const dataRes = await InventoryServices.updateInventory(formData, dataParams.id);
      if (dataRes) {
        message.success("Cập nhật thông tin thành công");
        onBackHome();
      }
    }
  });

  const onBackHome = () => {
    const filter = sessionStorage.getItem("filter");
    console.log(559, filter);
    // if (formValues["province"]) {
    //   navigate({
    //     pathname: PAGE_ROUTE.ADM_INVENTORY_LIST,
    //     search: createSearchParams({
    //       // code: String(formValues["province"]),
    //     }).toString(),
    //   });
    // }

    navigate({
      pathname: PAGE_ROUTE.ADM_INVENTORY_LIST,
      search: filter || "",
    });
  };

  const [hadleUploadFiles, loadingUpload] = useHandleSubmitApi(async (data) => {
    const formData = FormDataUtil.convertJsonToFormData(data, {
      handelObjectInArr: (input) => {
        const temp = FormDataUtil.transformObjectFormData({
          mainKey: input.mainKey,
          data: input.data,
          mainIdx: input.mainIdx,
          customKeyForm: ({ mainKey, key, mainIdx }) => {
            return `${mainKey}[${mainIdx}][${key}]`;
          },
        });
        return temp;
      },
    });
    const dataRes = await FileServices.createFiles(formData);
    if (dataRes) {
      // insertToEditor(dataRes.data[0].url);
      return dataRes.data[0].url;
    }
  });

  const invalidCoordinates = !!formValues.coordinates && OtherUtil.validateCoordinates(formValues.coordinates);
  const loadingAction = loadingCreate || loadingUpdate || loadingDetail || loadingUpload;
  const loadingTags = loadingRemoveTag || loadingCreateTag || loadingTag;

  const [visibleReviewContent, setVisibleReviewContent] = useState(false);

  return (
    <>
      <HistoryInventoryForm id={visibleHistory} onClose={() => setVisibleHistory(null)} />

      <Drawer
        width={"100vw"}
        title="Kiểm tra thông tin"
        placement="right"
        onClose={() => setVisibleReviewContent(false)}
        open={visibleReviewContent}
      >
        <div className="quill quill-editor">
          <div className="ql-container ql-snow">
            <div className="ql-editor">
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
            </div>
          </div>
        </div>
      </Drawer>

      <div className="layout-form">
        <div className="layout-form__content">
          <div style={{ maxWidth: "50rem", margin: "auto" }}>
            <div className="layout-form__title">
              {mode === FORM_MODE.CREATE ? "Tạo thông tin mới" : "Chỉnh sửa thông tin"}
            </div>
            {loadingDetail ? (
              <div className="layout-form__loading">
                <LogoLoading style={{ position: "absolute", top: 0 }} />
              </div>
            ) : (
              <Form
                form={form}
                className="w_100"
                layout="vertical"
                initialValues={formValues}
                onValuesChange={(values) => handleChangeFormValues(values)}
              >
                {true && (
                  <div className="w_100 d-flex justify-space-between">
                    <Row gutter={[20, 20]}>
                      <Col span={12}>
                        <Form.Item label={"Được hiển thị"}>
                          <Form.Item name="isShow" label={"Được hiển thị"} valuePropName="checked" noStyle>
                            <Switch />
                          </Form.Item>
                          <span className="ml_0-5">Hiển thị</span>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name={"label"} label={"Thẻ tiêu đề"}>
                          <Select
                            size="large"
                            placeholder={"Chọn thẻ tiêu đề cho toà nhà"}
                            className="w_100"
                            options={Object.keys(EInventoryLabel).map((key) => ({
                              label: t(key),
                              value: key,
                            }))}
                            allowClear
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={"buildingClass"}
                          label={"Hạng toà nhà"}
                          rules={[{ required: true, message: "Vui lòng chọn hạng toà nhà" }]}
                        >
                          <Select
                            size="large"
                            placeholder={"Chọn hạng toà nhà"}
                            className="w_100"
                            options={Object.keys(EInventoryBuildingClass).map((key) => ({
                              label: t(key),
                              value: key,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={"title"}
                          label="Tên toà nhà"
                          rules={[{ required: true, message: "Vui lòng nhập tên toà nhà" }]}
                        >
                          <Input size="large" placeholder="Nhập tên toà nhà" maxLength={150} showCount />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={"investorName"}
                          label="Tên nhà đầu tư"
                          rules={[{ required: true, message: "Vui lòng nhập tên nhà đầu tư" }]}
                        >
                          <Input size="large" placeholder="Nhập tên nhà đầu tư" maxLength={150} showCount />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name={"spaceTypeBuilding"}
                          label={"Loại hình không gian"}
                          rules={[{ required: true, message: "Vui lòng chọn Loại hình không gian" }]}
                        >
                          <Select
                            size="large"
                            placeholder={"Chọn Loại hình không gian"}
                            className="w_100"
                            options={Object.keys(EInventorySpaceType).map((key) => ({
                              label: t(key),
                              value: key,
                            }))}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={"price"}
                          label={`Khoảng giá (${CURRENCY})`}
                          rules={[{ required: true, message: "Vui lòng chọn khoảng giá" }]}
                        >
                          <Slider
                            range={{ draggableTrack: true }}
                            defaultValue={[formValues["price"][0], formValues["price"][1]]}
                          />
                        </Form.Item>
                        <div className="d-flex items-center justify-space-between" style={{ marginTop: "-1rem" }}>
                          <InputNumber
                            min={0}
                            max={100}
                            value={formValues["price"][0]}
                            defaultValue={formValues["price"][0]}
                            className="w_30"
                            onChange={(number) => {
                              formValues["price"][0] = number || 0;
                              handleChangeFormValues({ price: formValues["price"] } as any);
                            }}
                          />
                          <MinusOutlined />
                          <InputNumber
                            min={0}
                            max={100}
                            value={formValues["price"][1]}
                            defaultValue={formValues["price"][1]}
                            className="w_30"
                            onChange={(number) => {
                              formValues["price"][1] = number || 0;
                              handleChangeFormValues({ price: formValues["price"] } as any);
                            }}
                          />
                        </div>
                      </Col>

                      <Col span={12}></Col>

                      <Col span={12}>
                        <Form.Item
                          name={"typicalFloor"}
                          label="Sàn tiêu chuẩn (m2)"
                          rules={[{ required: true, message: "Vui lòng nhập sàn tiêu chuẩn" }]}
                        >
                          <InputNumber
                            size="large"
                            placeholder="Nhập sàn tiêu chuẩn"
                            maxLength={150}
                            className="w_100"
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={"operatingTime"}
                          label={"Năm khánh thành"}
                          rules={[{ required: true, message: "Vui lòng chọn năm khánh thành" }]}
                        >
                          <DatePicker
                            className="w_100"
                            size="large"
                            placeholder="Chọn thời gian"
                            // onChange={(date, dateString) => handleChangeFormValues({ operatingTime: dateString } as any)}
                            picker="year"
                            // disabledDate={(date) => dayjs(date).isAfter(new Date())}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={"parking"}
                          label="Chỗ đỗ xe"
                          rules={[{ required: true, message: "Vui lòng nhập chỗ đỗ xe" }]}
                        >
                          <TextArea size="large" placeholder="Nhập chỗ đỗ xe" className="w_100" />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={"powerBackup"}
                          label="Điện dự phòng"
                          rules={[{ required: true, message: "Vui lòng nhập điện dự phòng" }]}
                        >
                          <TextArea size="large" placeholder="Nhập điện dự phòng" className="w_100" />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <div className="layout-form__label-required">Các diện tích cho thuê</div>
                        <Form.Item
                          name={"areaRange"}
                          // rules={[{ required: true, message: "Vui lòng chọn diện tích cho thuê" }]}
                        >
                          {/* <Select
                          size="large"
                          placeholder={"Chọn diện tích cho thuê"}
                          className="w_100"
                          options={Object.keys(EInventoryRentalArea).map((key) => ({
                            label: (EInventoryRentalArea as any)[key],
                            value: key,
                          }))}
                        /> */}
                          {formValues["areaRange"].map((d, idx) => {
                            return (
                              <div className="mb_1 d-flex items-center justify-space-between" key={idx}>
                                <InputNumber
                                  value={formValues["areaRange"][idx]}
                                  defaultValue={formValues["areaRange"][idx]}
                                  className="w_90"
                                  onChange={(number) => {
                                    formValues["areaRange"][idx] = number || 0;
                                    handleChangeFormValues({ areaRange: formValues["areaRange"] } as any);
                                  }}
                                  size="large"
                                />

                                {formValues["areaRange"]?.length > 1 && (
                                  <Button
                                    type="primary"
                                    shape="circle"
                                    icon={"-"}
                                    danger
                                    onClick={() => {
                                      formValues["areaRange"].splice(idx, 1);
                                      handleChangeFormValues({ areaRange: formValues["areaRange"] } as any);
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                          <Button
                            type="dashed"
                            // shape="circle"
                            icon={"+ Thêm mới"}
                            size="large"
                            onClick={() => {
                              handleChangeFormValues({ areaRange: [...formValues["areaRange"], 0] } as any);
                            }}
                            style={{ width: "30%" }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          name={"totalRentalArea"}
                          label="Tổng diện tích cho thuê cả tòa (m2)"
                          // rules={[{ required: true, message: "Vui lòng nhập diện tích cho thuê cả tòa" }]}
                        >
                          <InputNumber
                            size="large"
                            placeholder="Nhập tổng diện tích cho thuê cả tòa"
                            maxLength={150}
                            className="w_100"
                            // max={5000}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={24} className="mt_2">
                        <Collapse defaultActiveKey={["province"]}>
                          <Panel header="Thông tin địa chỉ" key="province" className="mb_2">
                            <Row gutter={[20, 20]}>
                              <Col span={8}>
                                <Form.Item
                                  name={"province"}
                                  label="Tỉnh thành"
                                  rules={[{ required: true, message: "Vui lòng chọn tỉnh thành" }]}
                                >
                                  <Select
                                    size="large"
                                    placeholder={"Chọn tỉnh thành"}
                                    className="w_100"
                                    options={optionsProvince}
                                    // disabled
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item
                                  name={"district"}
                                  label="Quận/ Huyện"
                                  rules={[{ required: true, message: "Vui lòng chọn Quận/ Huyện" }]}
                                >
                                  <Select
                                    size="large"
                                    placeholder={"Chọn Quận/ Huyện"}
                                    className="w_100"
                                    options={optionsDistrict}
                                    disabled={!formValues["province"]}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item
                                  name={"ward"}
                                  label="Phường/ Xã"
                                  rules={[{ required: true, message: "Vui lòng chọn Phường/ Xã" }]}
                                >
                                  <Select
                                    size="large"
                                    placeholder={"Chọn Phường/ Xã"}
                                    className="w_100"
                                    options={optionsWard}
                                    disabled={!formValues["district"] || !formValues["province"]}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name={"address"}
                                  label="Địa chỉ"
                                  rules={[{ required: true, message: "Vui lòng nhập địa chỉ" }]}
                                >
                                  <Input size="large" placeholder="Ví dụ 268 Trần Hưng Đạo" maxLength={150} showCount />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name={"coordinates"}
                                  label="Toạ độ"
                                  rules={[
                                    { required: true, message: "Vui lòng nhập toạ độ" },
                                    ({ getFieldValue }) => ({
                                      validator(rule, value) {
                                        if (value && !OtherUtil.validateCoordinates(getFieldValue("coordinates"))) {
                                          return Promise.reject("Toạ độ không hợp lệ!");
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <Input
                                    size="large"
                                    placeholder="Ví dụ 10.9335, 106.73916"
                                    maxLength={150}
                                    showCount
                                  />
                                </Form.Item>
                              </Col>
                              {formValues.iframeMap && invalidCoordinates && (
                                <Col span={24}>
                                  <iframe
                                    style={{ border: "0", width: "100%", height: "20rem" }}
                                    src={formValues.iframeMap}
                                    title="Map"
                                  />
                                </Col>
                              )}
                            </Row>
                          </Panel>
                        </Collapse>
                      </Col>
                      <Col span={24}>
                        <Collapse
                        // defaultActiveKey={["inventory-information"]}
                        >
                          <Panel header="Thông số toà nhà" key="inventory-information" className="mb_2">
                            <Row gutter={[20, 20]}>
                              <Col span={12}>
                                <Form.Item name={"height"} label="Tổng số tầng">
                                  <Input size="large" placeholder="Nhập tổng số tầng" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"airConditioning"} label="Điều hoà">
                                  <Input size="large" placeholder="Nhập điều hoà" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              {/* <Col span={12}>
                              <Form.Item name={"parkingAvailable"} label="Phí đỗ ô tô">
                                <Input size="large" placeholder="Nhập phí đổ ô tô" maxLength={150} showCount />
                              </Form.Item>
                            </Col> */}

                              <Col span={12}>
                                <Form.Item name={"electricitySurcharge"} label="Điện ngoài giờ">
                                  <Input size="large" placeholder="Nhập điện ngoài giờ" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"workingHours"} label="Giờ làm việc">
                                  <Input size="large" placeholder="Nhập giờ làm việc" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"elevatorAvailable"} label="Thang máy">
                                  <Input size="large" placeholder="Nhập thang máy" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"buildingOrientation"} label="Hướng toà nhà">
                                  <Input size="large" placeholder="Nhập hướng toà nhà" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"imageBuildingOrientation"} label="Ảnh layout kèm hướng toà nhà">
                                  {/* <FileUpload
                                  // value={form.getFieldValue("content")}
                                  onChange={(value) => {
                                    form.setFieldValue("imageBuildingOrientation", value);
                                  }}
                                  showUploadList={false}
                                /> */}

                                  {/* <FileUploads
                                    // value={form.getFieldValue("inventoryImages")}
                                    onChange={(value) => {
                                      form.setFieldValue("imageBuildingOrientation", value);
                                    }}
                                    showUploadList={false}
                                  /> */}

                                  <InventoryImageForm
                                    value={formValues.imageBuildingOrientation}
                                    onChange={(value) => {
                                      console.log(1139, value);
                                      form.setFieldValue("imageBuildingOrientation", value);
                                    }}
                                  />
                                </Form.Item>
                              </Col>

                              <Divider orientation="left" plain>
                                Thông số diện tích
                              </Divider>

                              <Col span={12}>
                                <Form.Item name={"floorSpaceBuilding"} label="Tỉ lệ trống (%)">
                                  <InputNumber
                                    size="large"
                                    placeholder="Nhập tỉ lệ trống"
                                    maxLength={150}
                                    className="w_100"
                                    max={5000}
                                  />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"ceilingHeight"} label="Chiều cao trần">
                                  <InputNumber
                                    size="large"
                                    placeholder="Nhập chiều cao trần"
                                    maxLength={150}
                                    className="w_100"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                      </Col>
                      <Col span={24}>
                        <Collapse
                        // defaultActiveKey={["other-service"]}
                        >
                          <Panel
                            header="Chi tiết giá, phí dịch vụ và chi phí khác"
                            key="other-service"
                            className="mb_2"
                          >
                            <Row gutter={[20, 20]}>
                              {/* <Col span={12}>
                              <Form.Item name={"rentalPrice"} label="Giá thuê">
                                <Input size="large" placeholder="Nhập giá thuê" maxLength={150} showCount />
                              </Form.Item>
                            </Col> */}

                              <Col span={12}>
                                <Form.Item name={"serviceFee"} label="Phí dịch vụ">
                                  <Input size="large" placeholder="Nhập phí dịch vụ" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"tax"} label="Thuế VAT">
                                  <Input size="large" placeholder="Nhập thuế VAT" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"carParkingAvailable"} label="Phí gửi ô tô">
                                  <Input size="large" placeholder="Nhập gửi ô tô" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"motorcycleParkingAvailable"} label="Phí gửi xe máy">
                                  <Input size="large" placeholder="Nhập phí gửi xe máy" maxLength={150} showCount />
                                </Form.Item>
                              </Col>

                              <Col span={12}>
                                <Form.Item name={"electricityAirconIncluded"} label="Điện điều hoà">
                                  <Input size="large" placeholder="Nhập điện điều hoà" maxLength={150} showCount />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                      </Col>
                    </Row>
                  </div>
                )}

                <div className="w_100 mt_2">
                  <div className="layout-form__label">
                    Nội dung thông tin{" "}
                    <span
                      style={{ cursor: "pointer", color: "#d38123", fontStyle: "italic" }}
                      onClick={() => setVisibleReviewContent(true)}
                    >
                      ( Kiểm tra )
                    </span>
                  </div>
                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.TINY_MCE && (
                    <TinyEditor
                      content={content}
                      onChange={(value: any) => {
                        setContent(value);
                      }}
                    />
                  )}
                  {/* <QuillEditor
                    content={content}
                    onChange={(value) => {
                      setContent(value);
                    }}
                  /> */}
                  {/* <QuillEditorV2
                    content={content}
                    onChange={(value) => {
                      setContent(value);
                    }}
                    initialValue={initialContent}
                  /> */}
                  {APP_SETTINGS.EDITOR_TYPE === EEditorType.SUN_EDITOR && (
                    <SunEditorCustom
                      content={content}
                      onChange={(value: any) => {
                        setContent(value);
                      }}
                    />
                  )}
                  {/* <Ckeditor4
                    content={content}
                    onChange={(value: any) => {
                      setContent(value);
                    }}
                    // initialValue={initialContent as any}
                  /> */}
                  <Form.Item
                    name={"moreInformation"}
                    // rules={[
                    //   ({ getFieldValue }) => ({
                    //     validator(rule, value) {
                    //       if (!content) {
                    //         return Promise.reject("Vui lòng nhập lại nội dung!");
                    //       }
                    //       return Promise.resolve();
                    //     },
                    //   }),
                    // ]}
                  ></Form.Item>
                </div>

                <div className="w_100 mt_2">
                  <div className="layout-form__label-required">Hình ảnh hàng tồn kho</div>
                  <Form.Item
                    name={"inventoryImages"}
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn hình ảnh hàng tồn kho!",
                      },
                    ]}
                  >
                    {/* <FileUploads
                      // value={form.getFieldValue("inventoryImages")}
                      onChange={(value) => {
                        console.log(1162, value);
                        form.setFieldValue("inventoryImages", value);
                      }}
                      showUploadList={false}
                      thumbnail={selectedThumbnail}
                      onChangeThumbnail={(value) => setSelectedThumbnail(value)}
                    /> */}
                    <InventoryImageForm
                      isThumbnail
                      isMultipleSelect
                      value={formValues.inventoryImages}
                      // thumbnail={selectedThumbnail}
                      // onChangeThumbnail={(value) => setSelectedThumbnail(value)}
                      onChange={(value) => {
                        form.setFieldValue("inventoryImages", value);
                      }}
                    />
                  </Form.Item>
                </div>

                <Collapse defaultActiveKey={["seo"]}>
                  <Panel header="Thông tin SEO" key="seo">
                    <div className="d-flex justify-space-between">
                      <span className="layout-form__title"></span>
                      <div className="d-flex items-center">
                        <span className="mr_0-5">Chỉnh sửa SEO</span>
                        <Form.Item noStyle name="allowSeo" valuePropName="checked">
                          <Switch />
                        </Form.Item>
                      </div>
                    </div>
                    <Form.Item
                      name={"titleSeo"}
                      label={"Tiêu đề trang"}
                      rules={[
                        {
                          required: formValues["allowSeo"],
                          message: "Vui lòng nhập tiêu đề!",
                        },
                      ]}
                    >
                      <Input size="large" maxLength={150} showCount placeholder="Nhập tiêu đề" />
                    </Form.Item>

                    <Form.Item name={"keywords"} label={"Từ khoá bài viết"}>
                      {/* <TagsInput
                        value={formValues["keywords"]}
                        name="fruits"
                        placeHolder="Nhập từ khoá"
                        disabled={loadingTag}
                      /> */}

                      <Select
                        mode="multiple"
                        className="w_100"
                        size="large"
                        placeholder="Chọn từ khoá"
                        loading={loadingTags}
                        disabled={loadingTags}
                        filterOption={(input, option) =>
                          OtherUtil.convertSlugUnicode(option?.label ?? "")
                            .toLowerCase()
                            .includes(OtherUtil.convertSlugUnicode(input).toLowerCase())
                        }
                        onSelect={(value) => {
                          if (tags?.find((t) => t.id === value)) return;
                          handleCreateTag(value);
                        }}
                        dropdownRender={(menu: any) => (
                          <>
                            {menu}
                            <Divider style={{ margin: "8px 0" }} />

                            <Space style={{ padding: "0 8px 4px" }}>
                              <Input
                                placeholder="Nhập từ khoá"
                                onChange={(e) => setInputTag(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                                disabled={loadingTags}
                              />
                              <Button
                                loading={loadingTags}
                                type="text"
                                icon={<PlusOutlined />}
                                onClick={() => handleCreateTag(inputTag)}
                              >
                                Thêm mới
                              </Button>
                            </Space>
                          </>
                        )}
                        optionRender={(option) => (
                          <div className="d-flex items-center justify-space-between" style={{ height: "2rem" }}>
                            <p>{option.data.label}</p>

                            <Popconfirm
                              title="Xoá từ khoá?"
                              description="Bạn có chắc chắn muốn xoá từ khoá này?"
                              okText="Xác nhận"
                              cancelText="Không"
                              onCancel={(e) => {
                                e?.stopPropagation();
                                e?.preventDefault();
                              }}
                              onConfirm={(e) => {
                                e?.stopPropagation();
                                e?.preventDefault();

                                console.log(1365, option.value);

                                handleRemoveTag(option?.value as string);
                              }}
                            >
                              <Button
                                className="mr_1"
                                color="danger"
                                variant="dashed"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                }}
                              >
                                <CloseOutlined style={{ color: "red" }} />
                                Gỡ bỏ
                              </Button>
                            </Popconfirm>
                          </div>
                        )}
                        options={tags.map((item) => ({ label: item.name, value: item.id }))}
                      />
                    </Form.Item>

                    <Form.Item
                      name={"descSeo"}
                      label={"Mô tả"}
                      rules={[
                        {
                          required: formValues["allowSeo"],
                          message: "Vui lòng nhập mô tả!",
                        },
                      ]}
                    >
                      <TextArea placeholder="Nhập mô tả" rows={4} maxLength={500} showCount />
                    </Form.Item>

                    <Form.Item
                      name={"slug"}
                      label={"Đường dẫn"}
                      rules={[
                        {
                          required: formValues["allowSeo"],
                          message: "Vui lòng nhập tiêu đề!",
                        },
                      ]}
                    >
                      <Input size="large" maxLength={150} showCount placeholder="Nhập đường dẫn" disabled />
                    </Form.Item>
                  </Panel>
                </Collapse>
              </Form>
            )}
          </div>

          <div className="layout-form__footer">
            {!!dataParams?.id && (
              <Button size="large" className="btn btn-outline mr_1" onClick={() => setVisibleHistory(dataParams?.id)}>
                Lịch sử thay đổi
              </Button>
            )}
            <div className="ml-auto">
              <Button
                size="large"
                className="btn btn-outline mr_1"
                style={{ width: 100 }}
                disabled={loadingAction}
                onClick={() => setVisibleExit(true)}
              >
                Hủy
              </Button>
              <Button
                size="large"
                className="btn"
                style={{ width: 100 }}
                loading={loadingAction}
                disabled={loadingAction}
                onClick={() => form.validateFields().then(handleSubmitApi)}
              >
                Lưu
              </Button>
            </div>
          </div>
        </div>
      </div>

      {visibleExit && (
        <ModalConfirm
          visible={visibleExit}
          title="Bạn có chắc chắn muốn thoát?"
          cancel={() => setVisibleExit(false)}
          confirm={() => {
            setVisibleExit(false);
            onBackHome();
          }}
        />
      )}
    </>
  );
};

export default InventoryFormPresenter;
